import { useEffect, useState } from "react";
import * as S from "./styles";
import { useTournamentTicketStore } from "./hooks/use-tournament-ticket-store";
import Table from "./components/table/table";
import BuyPopup from "./components/buy-popup";
import TicketLogPopup from "../tournament-ticket-member/components/ticket-log-popup";
import { TournamentTicketResponseForSeller } from "../../api/tournament-ticket";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { PubOwnerRole, PubOwnerDomain } from "../../api/cafe";
import { pubState } from "../../recoil/pub.atom";

const TournamentTicketStore = () => {
  const {
    currentPage,
    setCurrentPage,
    totalPages,
    tournamentTicketList,
    totalCount,
    pubCarrot,
    searchQuery,
    handleSearchQueryChange,
    pubId,
    buyTournamentTicket,
    logPopupOpen,
    setLogPopupOpen,
    openLogPopup,
    logList,
    logPage,
    setLogPage,
    logTotalPages,
  } = useTournamentTicketStore();

  const [selectedTicket, setSelectedTicket] =
    useState<TournamentTicketResponseForSeller | null>(null);
  const pub = useRecoilValue(pubState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.TICKET)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const handleBuyConfirm = async (count: number) => {
    if (!selectedTicket) return false;
    return buyTournamentTicket({
      ticketId: selectedTicket.id,
      count,
      pubId: pubId,
    });
  };

  return (
    <S.TournamentTicketStoreWrapper>
      <S.TitleRow>
        <S.Title>매장 티켓 </S.Title>
        <S.LogButton onClick={openLogPopup}>티켓 내역</S.LogButton>
      </S.TitleRow>
      <S.HeaderWrapper>
        <div className="box">
          <div className="label">매장 보유 캐럿:</div>
          <div className="seed">{pubCarrot.toLocaleString()} 캐럿</div>
        </div>
        <div className="box">
          <div className="label">교환 가능 티켓:</div>
          <div className="value">{totalCount}종</div>
        </div>
      </S.HeaderWrapper>
      <Table
        list={tournamentTicketList}
        searchQuery={searchQuery}
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        handleSearchQueryChange={handleSearchQueryChange}
        onBuy={setSelectedTicket}
      />
      {logPopupOpen && (
        <TicketLogPopup
          list={logList}
          currentPage={logPage}
          totalPages={logTotalPages}
          onClose={() => setLogPopupOpen(false)}
          onPageChange={setLogPage}
        />
      )}
      {selectedTicket && (
        <BuyPopup
          ticket={selectedTicket}
          pubCarrot={pubCarrot}
          onClose={() => setSelectedTicket(null)}
          onConfirm={handleBuyConfirm}
        />
      )}
    </S.TournamentTicketStoreWrapper>
  );
};

export default TournamentTicketStore;
